
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { NewsItem } from '../../../types/news';

interface MegaMenuProps {
  type: 'services' | 'solutions';
}

export default function MegaMenu({ type }: MegaMenuProps) {
  const { t } = useTranslation();
  const [latestNews, setLatestNews] = useState<NewsItem[]>([]);

  useEffect(() => {
    const saved = localStorage.getItem('newsItems');
    if (saved) {
      const allNews = JSON.parse(saved);
      setLatestNews(allNews.slice(0, 3));
    }
  }, []);

  const handleNavigation = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
  };

  return (
    <div className="fixed left-0 right-0 top-[120px] w-full bg-white shadow-2xl z-50">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-3 gap-12">
          {/* Services Section */}
          {type === 'services' && (
            <>
              <div>
                <h3 className="text-xl font-black mb-6 text-gray-900">서비스</h3>
                <ul className="space-y-4">
                  <li>
                    <a 
                      onClick={() => handleNavigation('/content-production')}
                      className="text-gray-700 hover:text-secondary transition-colors flex items-center group cursor-pointer"
                    >
                      <i className="ri-film-line mr-3 text-xl text-secondary"></i>
                      <span className="group-hover:translate-x-1 transition-transform">콘텐츠 제작</span>
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavigation('/live-streaming')}
                      className="text-gray-700 hover:text-secondary transition-colors flex items-center group cursor-pointer"
                    >
                      <i className="ri-live-line mr-3 text-xl text-secondary"></i>
                      <span className="group-hover:translate-x-1 transition-transform">라이브 스트리밍</span>
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavigation('/on-site-service')}
                      className="text-gray-700 hover:text-secondary transition-colors flex items-center group cursor-pointer"
                    >
                      <i className="ri-map-pin-line mr-3 text-xl text-secondary"></i>
                      <span className="group-hover:translate-x-1 transition-transform">현장 출장</span>
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavigation('/studio-consulting')}
                      className="text-gray-700 hover:text-secondary transition-colors flex items-center group cursor-pointer"
                    >
                      <i className="ri-building-4-line mr-3 text-xl text-secondary"></i>
                      <span className="group-hover:translate-x-1 transition-transform">스튜디오 컨설팅</span>
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavigation('/ai-content')}
                      className="text-gray-700 hover:text-secondary transition-colors flex items-center group cursor-pointer"
                    >
                      <i className="ri-robot-2-line mr-3 text-xl text-secondary"></i>
                      <span className="group-hover:translate-x-1 transition-transform">AI 콘텐츠 제작</span>
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-black mb-6 text-gray-900">특징</h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-secondary text-xl mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">전문 장비</h4>
                      <p className="text-sm text-gray-600">최신 방송 장비로 고품질 콘텐츠 제작</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-secondary text-xl mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">숙련된 팀</h4>
                      <p className="text-sm text-gray-600">10년 이상 경력의 전문가 팀</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-secondary text-xl mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">맞춤 솔루션</h4>
                      <p className="text-sm text-gray-600">고객 니즈에 맞는 최적의 서비스</p>
                    </div>
                  </li>
                </ul>
              </div>
            </>
          )}

          {/* Solutions Section */}
          {type === 'solutions' && (
            <>
              <div>
                <h3 className="text-xl font-black mb-6 text-gray-900">솔루션</h3>
                <ul className="space-y-4">
                  <li>
                    <a 
                      onClick={() => handleNavigation('/integrated-solution')}
                      className="text-gray-700 hover:text-secondary transition-colors flex items-center group cursor-pointer"
                    >
                      <i className="ri-stack-line mr-3 text-xl text-secondary"></i>
                      <span className="group-hover:translate-x-1 transition-transform">통합 운영 솔루션</span>
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavigation('/university-solution')}
                      className="text-gray-700 hover:text-secondary transition-colors flex items-center group cursor-pointer"
                    >
                      <i className="ri-team-line mr-3 text-xl text-secondary"></i>
                      <span className="group-hover:translate-x-1 transition-transform">협회 제작 사례</span>
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavigation('/public-solution')}
                      className="text-gray-700 hover:text-secondary transition-colors flex items-center group cursor-pointer"
                    >
                      <i className="ri-government-line mr-3 text-xl text-secondary"></i>
                      <span className="group-hover:translate-x-1 transition-transform">공공 제작 사례</span>
                    </a>
                  </li>
                  <li>
                    <a 
                      onClick={() => handleNavigation('/enterprise-solution')}
                      className="text-gray-700 hover:text-secondary transition-colors flex items-center group cursor-pointer"
                    >
                      <i className="ri-building-line mr-3 text-xl text-secondary"></i>
                      <span className="group-hover:translate-x-1 transition-transform">기업 제작 사례</span>
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-black mb-6 text-gray-900">주요 고객</h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <i className="ri-building-2-line text-secondary text-xl mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">대학교</h4>
                      <p className="text-sm text-gray-600">교육 콘텐츠 제작 및 스튜디오 구축</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-government-line text-secondary text-xl mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">공공기관</h4>
                      <p className="text-sm text-gray-600">정책 홍보 및 교육 영상 제작</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-building-line text-secondary text-xl mt-1"></i>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">기업</h4>
                      <p className="text-sm text-gray-600">브랜드 콘텐츠 및 마케팅 영상</p>
                    </div>
                  </li>
                </ul>
              </div>
            </>
          )}

          {/* Latest News Section */}
          <div>
            <h3 className="text-xl font-black mb-6 text-gray-900">최신 뉴스</h3>
            <div className="space-y-4">
              {latestNews.length > 0 ? (
                latestNews.map((news) => (
                  <a
                    key={news.id}
                    onClick={() => handleNavigation('/news')}
                    className="flex gap-3 cursor-pointer group"
                  >
                    <div className="w-20 h-20 flex-shrink-0 overflow-hidden rounded-lg">
                      <img
                        src={news.imageUrl}
                        alt={news.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-bold text-gray-900 group-hover:text-secondary transition-colors line-clamp-2 mb-1">
                        {news.title}
                      </h4>
                      <p className="text-xs text-gray-500">{news.date}</p>
                    </div>
                  </a>
                ))
              ) : (
                <p className="text-sm text-gray-500">등록된 뉴스가 없습니다.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
